import { Box, Flex, Grid, GridItem, Image, useColorMode } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { assets } from "../../../assets/assets";
import { AcceptOrgUserInvite } from "../../../common/email-invites/AcceptOrgUserInvite";
import { useQueryParams } from "../../../common/useQueryParams";
import { requireStringEnvVar } from "../../../config";
import { AcceptContributingEntityInvite } from "./AcceptContributingEntityInvite";
import { AcceptMarketDialogueInvite } from "./AcceptMarketDialogueInvite";
import { AcceptSourcingEventEmailInvite } from "./AcceptSourcingEventEmailInvite";
import { parseEmailInviteType } from "./parseEmailinviteType";

export const AcceptEmailInviteWhenLoggedInWithOrgContext = () => {
  const { emailInviteId } = useParams();
  const params = useQueryParams();
  const secret = params.get("secret");
  const rawType = params.get("type");
  const type = parseEmailInviteType(rawType);
  const { t } = useTranslation();
  const theme = useColorMode();
  if (!emailInviteId || !secret || !type) {
    return <div>{t("Invalid invite params!")}</div>;
  }

  let content = null;
  switch (type) {
    case "SourcingEvent":
      content = <AcceptSourcingEventEmailInvite inviteId={emailInviteId} secret={secret} />;
      break;
    case "Supplier":
      window.location.replace(requireStringEnvVar("VITE_WEBAPP_BASE_URL"));
      break;
    case "OrgUser":
      content = <AcceptOrgUserInvite inviteId={emailInviteId} secret={secret} />;
      break;
    case "ContributingEntity":
      content = <AcceptContributingEntityInvite inviteId={emailInviteId} secret={secret} />;
      break;
    case "MarketDialogue":
      content = <AcceptMarketDialogueInvite inviteId={emailInviteId} secret={secret} />;
      break;
  }
  return (
    <Box
      width="full"
      height="100vh"
      bgGradient="linear(to-br, smTealShadow, smBackground, smBackground, smBackground, smBlueShadow)"
    >
      <Grid
        gridTemplateColumns={"1fr 450px 1fr"}
        height="100%"
        gridTemplateRows={"1fr auto 2fr"}
        templateAreas={`
                "left top right"
                "left login right"
                "left bottom right"
                `}
      >
        <GridItem
          area={"login"}
          rounded="lg"
          backgroundColor="smBackground"
          boxShadow="smAuthCard"
          padding={10}
        >
          <Flex w="100%" h={"100%"} flexDirection="column">
            <Flex>
              <Image src={theme.colorMode === "dark" ? assets.logo_dark : assets.logo} alt="SourceMagnet" h="30px" mt="10px" />
            </Flex>
            <br /> <br />
            {content}
          </Flex>
        </GridItem>
      </Grid>
    </Box>
  );
};
